import { mutatorAction } from 'satcheljs';
import getRegionalOptions from '../store/store';
export default mutatorAction('setRenameFoldersOption', function setRenameFoldersOption(shouldRenameFolders) {
    getRegionalOptions().shouldRenameDefaultFolders = shouldRenameFolders;
});
//# sourceMappingURL=setRenameFoldersOption.js.map